var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoTextRightNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 611,
    height: 150,
    viewBox: "0 0 611 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1224_13172)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.54 146.968C65.71 150.528 73.32 150.518 79.48 146.938L92.59 139.318L45.94 112.388C31.84 104.248 23.15 89.2076 23.15 72.9276V19.0376L9.99001 26.5976C3.81001 30.1476 0 36.7176 0 43.8476V86.1476C0 102.518 8.73 117.648 22.91 125.828L59.54 146.978V146.968Z",
    fill: "url(#paint0_linear_1224_13172)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.7201 4.8275C69.3301 8.1875 63.8901 15.0675 62.5201 23.3275C62.3001 24.6375 62.1901 25.9875 62.1901 27.3575V63.3075C62.1901 67.4475 63.3101 71.4275 65.3101 74.8875C67.3001 78.3475 70.2001 81.2875 73.7801 83.3575L84.8901 89.7575C90.4901 92.9775 96.9701 94.8175 103.89 94.8175C114.85 94.8175 124.74 90.1975 131.7 82.7975V103.478C131.7 107.598 130.6 111.548 128.62 114.998C126.62 118.468 123.73 121.418 120.14 123.498C112.99 127.628 104.18 127.628 97.0301 123.498L73.3201 109.817L56.0801 99.8575C45.5501 93.7875 39.0701 82.5475 39.0701 70.3975V23.1175C39.0701 18.9875 40.1701 15.0075 42.1701 11.5575C44.1601 8.0975 47.0501 5.1575 50.6301 3.0975C57.7901 -1.0325 66.6001 -1.0325 73.7501 3.0975L76.7501 4.8275H76.7201Z",
    fill: "url(#paint1_linear_1224_13172)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.68 26.7473C125.21 32.8273 131.69 44.0473 131.69 56.2073V56.2473C131.69 71.2573 119.94 83.8673 104.94 84.4273C102.09 84.5373 99.3301 84.2073 96.7201 83.5173C103.6 79.6473 108.55 72.3473 108.55 63.3073C108.55 57.2073 106.16 51.4573 102.03 47.1873C100.56 45.6573 98.8601 44.3273 96.9701 43.2373L72.5701 29.1473V27.4273C72.5701 19.4473 79.0401 12.9873 87.0101 12.9873C89.4601 12.9873 91.7701 13.5973 93.7901 14.6773L114.68 26.7473Z",
    fill: "url(#paint2_linear_1224_13172)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.5 93.1275V33.6475H168.64V100.597C168.64 103.807 171.24 106.407 174.45 106.407H216.57V93.1275H182.49H182.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.25 31.9175C225.21 31.9175 221.74 35.3775 221.74 39.4275C221.74 43.4775 225.21 46.9375 229.25 46.9375C233.29 46.9375 236.76 43.4775 236.76 39.4275C236.76 35.3775 233.29 31.9175 229.25 31.9175ZM222.32 53.2775V106.407H235.6V53.2775H222.32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.93 53.2773C287.11 53.2773 285.46 54.3473 284.72 56.0073L283.62 58.4673C282.35 57.4273 281.08 56.3873 279.58 55.5873C276.93 54.1973 273.23 52.6973 268.61 52.6973C255.33 52.6973 243.78 64.1273 243.78 79.8373C243.78 95.5473 255.33 106.977 268.61 106.977C272.89 106.977 276.35 105.707 278.77 104.437C280.16 103.627 281.43 102.817 282.47 101.777V119.067C282.47 122.277 285.07 124.877 288.28 124.877H295.75V53.2673H288.93V53.2773ZM270.34 94.2773C262.83 94.2773 257.06 88.6173 257.06 79.8473C257.06 71.0773 262.83 65.4073 270.34 65.4073C277.85 65.4073 283.62 71.0673 283.62 79.8473C283.62 88.6273 277.85 94.2773 270.34 94.2773Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.25 53.2773V82.7273C342.25 89.6573 337.74 94.2773 331.27 94.2773C324.8 94.2773 320.3 89.6573 320.3 82.7273V53.2773H307.02V84.4673C307.02 98.3273 315.8 106.997 328.39 106.997C332.66 106.997 336.47 105.607 339.13 104.107C340.63 103.297 342.14 102.257 343.41 101.217L344.5 103.677C345.24 105.337 346.89 106.417 348.71 106.417H355.53V53.2873H342.25V53.2773Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.98 31.9175C369.94 31.9175 366.47 35.3775 366.47 39.4275C366.47 43.4775 369.93 46.9375 373.98 46.9375C378.03 46.9375 381.49 43.4775 381.49 39.4275C381.49 35.3775 378.03 31.9175 373.98 31.9175ZM367.05 53.2775V106.407H380.33V53.2775H367.05Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.2 39.4577V57.8977C426.16 56.9677 424.89 56.1677 423.5 55.3577C421.08 54.0877 417.61 52.6977 413.34 52.6977C400.06 52.6977 388.51 64.1277 388.51 79.8377C388.51 95.5477 400.06 106.978 413.34 106.978C417.96 106.978 421.65 105.588 424.31 104.088C425.81 103.278 427.08 102.238 428.35 101.198L429.44 103.658C430.18 105.328 431.83 106.398 433.66 106.398H440.48V33.6377H433.01C429.8 33.6377 427.2 36.2377 427.2 39.4477V39.4577ZM415.07 94.2777C407.56 94.2777 401.79 88.6177 401.79 79.8477C401.79 71.0777 407.56 65.4077 415.07 65.4077C422.58 65.4077 428.35 71.0677 428.35 79.8477C428.35 88.6277 422.57 94.2777 415.07 94.2777Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.92 31.9175C454.88 31.9175 451.41 35.3775 451.41 39.4275C451.41 43.4775 454.87 46.9375 458.92 46.9375C462.97 46.9375 466.43 43.4775 466.43 39.4275C466.43 35.3775 462.97 31.9175 458.92 31.9175ZM451.99 53.2775V106.407H465.27V53.2775H451.99Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.44 53.2773V82.7273C511.44 89.6573 506.94 94.2773 500.47 94.2773C494 94.2773 489.49 89.6573 489.49 82.7273V53.2773H476.21V84.4673C476.21 98.3273 484.99 106.997 497.57 106.997C501.85 106.997 505.66 105.607 508.31 104.107C509.81 103.297 511.31 102.257 512.58 101.217L513.67 103.677C514.42 105.337 516.06 106.417 517.88 106.417H524.7V53.2873H511.42L511.44 53.2773Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M591.66 52.7073C587.04 52.7073 583.12 54.4373 580.34 56.1673C578.72 57.2073 577.33 58.3573 576.06 59.6273C575.25 58.3573 574.1 57.2073 572.71 56.1673C570.29 54.4373 566.47 52.7073 561.04 52.7073C557.23 52.7073 554.11 54.2073 551.91 55.5973C550.64 56.4073 549.37 57.4373 548.33 58.4773L547.24 56.0173C546.5 54.3473 544.85 53.2773 543.03 53.2773H536.21V106.407H549.49V75.7973C549.49 69.3273 553.53 65.3973 558.15 65.3973C562.77 65.3973 566.82 69.3273 566.82 75.7973V106.407H580.1V75.7973C580.1 69.3273 584.14 65.3973 588.77 65.3973C593.4 65.3973 597.43 69.3273 597.43 75.7973V106.407H610.71V74.6473C610.71 60.2073 603.2 52.6973 591.65 52.6973L591.66 52.7073Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1224_13172",
    x1: -2.73,
    y1: 33.9376,
    x2: 66.75,
    y2: 154.288,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#F6B360"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F36C64"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1224_13172",
    x1: 42.8801,
    y1: 7.5675,
    x2: 112.39,
    y2: 127.978,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#F6B360"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F36C64"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1224_13172",
    x1: 83.7801,
    y1: 12.6173,
    x2: 121.75,
    y2: 78.3873,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F14A66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#F03367"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1224_13172"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 611,
    height: 150,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoTextRightNew);
export default __webpack_public_path__ + "static/media/logo-text-right-new.a92b59d824b102ee18a242fdf21614a8.svg";
export { ForwardRef as ReactComponent };